<script lang="ts" setup>
import { computed } from 'vue'

import cn from 'internal/tailwind-classmerge'

import { type DialogOverlayProps, DrawerOverlay } from '@fond-of/fondof-ui'

const props = defineProps<DialogOverlayProps>()

const delegatedProps = computed(() => {
  const { class: _, ...delegatedProps } = props
  return delegatedProps
})
</script>

<template>
  <DrawerOverlay
    v-bind="delegatedProps"
    :class="cn('fixed inset-0 z-50 bg-white/60', props.class)"
  />
</template>
